import { createEntityAdapter } from '@ngrx/entity';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';
import { AuditLog } from '../+models/audit-log.model';

function sortAudits<T extends AuditLog>(a: T, b: T) {
  return a.auditLogId > b.auditLogId ? -1 : 1;
}

// Entity Adapters
export const auditLogAdapter = createEntityAdapter<AuditLog>({
  selectId: p => p.auditLogId,
  sortComparer: sortAudits
});

export const refTypeItemAdapter = createEntityAdapter<RefTypeItem>({
  selectId: p => p.id
});

// Entity Selectors
export const auditLogSelectors = auditLogAdapter.getSelectors();
export const refTypeItemSelectors = refTypeItemAdapter.getSelectors();
